import style from './TextButton.module.css';
import PropTypes from 'prop-types';
const fontSizeMap = {
  small: '0.579rem',
  medium: '0.694rem',
  large: '1rem',
};

function TextButton({
  children,
  clickHandler,
  color,
  backgroundColor,
  width,
  fontSize,
  type,
  margin,
  height,
  padding,
  disabled,
  title,
  lineHeight,
  dataCommand,
}) {
  return (
    <button
      title={title}
      data-command={dataCommand}
      disabled={disabled}
      type={type}
      onClick={clickHandler}
      className={style.button}
      style={{ color, backgroundColor, width, fontSize: fontSizeMap[fontSize], margin, height, padding, lineHeight }}
    >
      {children}
    </button>
  );
}
TextButton.propTypes = {
  children: PropTypes.string.isRequired,
  clickHandler: PropTypes.func.isRequired,
  color: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  width: PropTypes.string,
  fontSize: PropTypes.string,
  type: PropTypes.string,
  margin: PropTypes.string,
  height: PropTypes.string,
  padding: PropTypes.string,
  disabled: PropTypes.any,
  title: PropTypes.string,
  dataCommand: PropTypes.string,
  lineHeight: PropTypes.string,
};
TextButton.defaultProps = {
  disabled: false,
  fontSize: '12px',
  type: 'button',
  color: 'white',
  backgroundColor: 'blue',
  width: '100%',
};
export default TextButton;
